module.exports = __webpack_public_path__ + "static/img/20260309-2.a5fa37b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20260309-2.jpg
// module id = 2tzP
// module chunks = 100